import { useState, Fragment, useEffect } from "react";
import { sendApiRequest } from "../../services/Base/base-service";

import EmailSentModal from "./EmailSentModal";
import {
  Alert,
  Button,
  FormGroup,
  Icon,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "design-react-kit";

const RecoverPasswordModal = ({ modalOpen, modalCloseHandler }) => {
  const [email, setEmail] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [emailSentModalOpen, setEmailSentModalOpen] = useState(false);

  const emailSentModalCloseHandler = () => {
    setEmailSentModalOpen(false);
  };

  useEffect(() => {
    if (modalOpen) {
      setError(null);
    }
  }, [modalOpen]);

  useEffect(() => {
    if (modalOpen) {
      const emailRegex = new RegExp(
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/gm
      );
      const isValidEmail = emailRegex.test(email);
      setTimeout(() => {
        if (!isValidEmail) {
          document.getElementById("sent-mail").disabled = true;
        } else {
          document.getElementById("sent-mail").disabled = false;
        }
      }, 300);
    }
  }, [email, modalOpen]);

  const resetPasswordHandler = (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    sendApiRequest(
      "Password/RequestResetPassword",
      "POST",
      false,
      { userEmail: email },
      null,
      null,
      null
    ).then((response) => {
      if (response.errors !== null) {
        setError(response.errors);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setEmailSentModalOpen(true);
        modalCloseHandler();
      }
    });
  };

  return (
    <Fragment>
      <Modal isOpen={modalOpen} toggle={modalCloseHandler}>
        <ModalHeader toggle={modalCloseHandler}>
          Recupera Credenziali
        </ModalHeader>
        <ModalBody className="text-center">
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mb-5">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}

          <FormGroup className="col-sm-12 m-0 position-relative mb-5">
            <Input
              id="email"
              type="email"
              label="Inserisci email di riferimento"
              placeholder="Inserisci email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormGroup>
          {isLoading && (
            <p style={{ height: "50px" }}>
              <Spinner double active />
            </p>
          )}
          <div className="col-sm-12 mb-2 d-flex align-items-center justify-content-end">
            <Button color="white" className="mr-2" onClick={modalCloseHandler}>
              Annulla
            </Button>
            <Button
              style={{
                backgroundColor: "#5EB423",
                color: "#fff",
                padding: "7px 15px",
              }}
              id="sent-mail"
              type="submit"
              onClick={(e) => resetPasswordHandler(e)}
            >
              <Icon icon="it-check" fill="#ffffff" /> Conferma
            </Button>
          </div>
        </ModalBody>
      </Modal>
      <EmailSentModal
        modalOpen={emailSentModalOpen}
        modalCloseHandler={emailSentModalCloseHandler}
        message={
          "Se l'indirizzo e-mail fornito corrisponde ad un utente registrato, EasyNotification invierà a questo indirizzo il link per procedere con l'inserimento della nuova password."
        }
      />
    </Fragment>
  );
};

export default RecoverPasswordModal;
